import { MultiSelect, Select } from "@mantine/core";
import { LANGUAGE_GROUPS } from "@config/languages";

const data = LANGUAGE_GROUPS.map((g) => ({
  group: g.group,
  items: g.items.map((i) => ({ value: i.value, label: i.label })),
}));

interface SingleProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

export const SourceLanguageSelect: React.FC<SingleProps> = ({
  value,
  onChange,
  label,
  disabled,
}) => (
  <Select
    label={label}
    aria-label={label ?? "Language"}
    data={data}
    value={value}
    onChange={(v) => v && onChange(v)}
    disabled={disabled}
    searchable
    allowDeselect={false}
    comboboxProps={{ withinPortal: true }}
    maxDropdownHeight={280}
    w={{ base: "100%", xs: 180 }}
  />
);

interface MultiProps {
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const TargetLanguageSelect: React.FC<MultiProps> = ({
  value,
  onChange,
  label,
  placeholder,
  disabled,
}) => (
  <MultiSelect
    label={label}
    aria-label={label ?? placeholder ?? "Target languages"}
    placeholder={value.length === 0 ? placeholder : undefined}
    data={data}
    value={value}
    onChange={onChange}
    disabled={disabled}
    searchable
    clearable
    hidePickedOptions
    comboboxProps={{ withinPortal: true }}
    maxDropdownHeight={280}
  />
);

interface SingleTargetProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

/** Single target language select (used by batch translation). */
export const SingleTargetLanguageSelect: React.FC<SingleTargetProps> = ({
  value,
  onChange,
  label,
  disabled,
}) => (
  <Select
    label={label}
    aria-label={label ?? "Target language"}
    data={data}
    value={value}
    onChange={(v) => v && onChange(v)}
    disabled={disabled}
    searchable
    allowDeselect={false}
    comboboxProps={{ withinPortal: true }}
    maxDropdownHeight={280}
    w={{ base: "100%", xs: 180 }}
  />
);
